function updatePricePerMeter(variantId, root) {
  if (!variantId) return;

  const scope = root || document;
  const id = String(variantId);

  scope.querySelectorAll('[data-price-per-meter]').forEach((el) => {
    const row = el.querySelector(`[data-variant-id="${id}"]`);
    const valueEl = el.querySelector('[data-price-per-meter-value]');

    if (!row || !valueEl) {
      el.classList.add('hidden');
      if (valueEl) valueEl.textContent = '';
      return;
    }

    valueEl.textContent = row.dataset.formattedPrice || '';
    el.classList.remove('hidden');
    el.dataset.currentVariantId = id;
  });
}

document.addEventListener('variant:change', (event) => {
  updatePricePerMeter(event.detail && event.detail.variant && event.detail.variant.id);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-price-per-meter]').forEach((el) => {
    updatePricePerMeter(el.dataset.currentVariantId, el.parentElement || document);
  });
});
